<template>
    <div>
        <v-btn
            v-if="showCopy"
            :disabled="disabled"
            class="mr-2"
            @click="copyClick"
            color="secondary"
            data-tour="wm-btn-copy"
        >
            <v-icon class="mr-2">mdi-content-copy</v-icon>
            Copy
        </v-btn>
        <v-btn
            v-if="showEdit"
            :disabled="disabled"
            class="mr-2"
            @click="editClick"
            color="primary"
            data-tour="wm-btn-edit"
        >
            <v-icon class="mr-2">mdi-pencil</v-icon>
            Edit
        </v-btn>
        <v-btn v-if="showSubmit" :disabled="disabled" class="mr-2" @click="submitClick" color="warning">
            <v-icon class="mr-2">mdi-send</v-icon>
            Submit
        </v-btn>
        <v-btn
            v-if="showArchive"
            :disabled="disabled"
            class="mr-2"
            @click="archiveClick"
            dark
            color="black"
            data-tour="wm-btn-archive"
        >
            <v-icon class="mr-2">mdi-delete-outline</v-icon>
            Archive
        </v-btn>
        <v-btn v-if="showUnarchive" :disabled="disabled" class="mr-2" @click="unarchiveClick" dark color="black">
            <v-icon class="mr-2">mdi-delete-restore</v-icon>
            Unarchive
        </v-btn>
        <!-- <div class="d-flex justify-center justify-md-end mt-2"> -->
        <v-btn v-if="showApprove" :disabled="disabled" class="mr-2" @click="approveClick" color="success">
            <v-icon class="mr-2">mdi-check-outline</v-icon>
            Approve
        </v-btn>
        <v-btn v-if="showFlag" :disabled="disabled" class="mr-2" @click="flagClick" color="info">
            <v-icon class="mr-2">mdi-flag-outline</v-icon>
            Flag
        </v-btn>
        <!-- </div> -->
        <v-btn
            v-if="showSave"
            :disabled="disabled"
            class="mr-2"
            @click="saveClick(false)"
            color="success"
            data-tour="wm-btn-save"
        >
            <v-icon class="mr-2">mdi-content-save-outline</v-icon>
            <span class="d-none d-sm-inline">Save</span>
        </v-btn>
        <v-btn
            v-if="showSave"
            :disabled="disabled"
            class="mr-2"
            @click="saveClick(true)"
            color="success"
            data-tour="wm-btn-save-close"
        >
            <v-icon class="mr-2">mdi-content-save-outline</v-icon>
            <span class="d-none d-sm-inline">Save and Close</span>
        </v-btn>
        <v-btn
            v-if="showCancel"
            :disabled="disabled"
            class="mr-2"
            @click="cancelClick"
            color="red"
            data-tour="wm-btn-cancel"
        >
            <v-icon class="mr-sm-2">mdi-cancel</v-icon>
            <span class="d-none d-sm-inline">Cancel</span>
        </v-btn>
        <v-btn
            v-if="showClose"
            :disabled="disabled"
            class="mr-2"
            @click="closeClick"
            color="info"
            data-tour="wm-btn-close"
        >
            <v-icon class="mr-2">mdi-close</v-icon>
            Close
        </v-btn>
    </div>
</template>
<script>
const states = ['Read', 'Edit', 'Create']
import permissionsSet from './permissions'
export default {
    name: 'ActionButtons',
    props: {
        state: {
            type: String,
            required: true,
            validator: value => {
                return states.includes(value)
            },
        },
        permissions: {
            type: Array,
            required: true,
        },
        entityStatus: {
            type: Number,
            required: false,
            default: 0,
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false,
        },
        isDirty: {
            type: Boolean,
            required: false,
            default: true,
        },
        allowCopy: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    computed: {
        isReadMode() {
            return this.state === 'Read'
        },
        isEditMode() {
            return this.state === 'Edit'
        },
        isCreateMode() {
            return this.state === 'Create'
        },
        canEditOrLimited() {
            return (
                this.permissions.includes(permissionsSet.Edit) ||
                this.permissions.includes(permissionsSet.EditLimited)
            )
        },
        showEdit() {
            return this.isReadMode && this.canEditOrLimited && this.entityStatus > -1
        },
        showCopy() {
            return (
                this.isReadMode &&
                (this.permissions.includes(permissionsSet.Create) ||
                    this.permissions.includes(permissionsSet.CanCopyAsOwn)) &&
                this.allowCopy
            )
        },
        showSubmit() {
            return this.isReadMode && this.permissions.includes(permissionsSet.Submit) && this.entityStatus == 0
        },
        showArchive() {
            return this.isReadMode && this.permissions.includes(permissionsSet.Delete) && this.entityStatus > -1
        },
        showApprove() {
            return (
                this.isReadMode &&
                this.permissions.includes(permissionsSet.Approve) &&
                this.entityStatus > -1 &&
                this.entityStatus != 3
            )
        },
        showFlag() {
            return (
                this.isReadMode &&
                this.permissions.includes(permissionsSet.Approve) &&
                this.entityStatus > -1 &&
                this.entityStatus != 5
            )
        },
        showSave() {
            return (
                ((this.isEditMode && this.canEditOrLimited) ||
                    (this.isCreateMode && this.permissions.includes(permissionsSet.Create))) &&
                this.isDirty
            )
        },
        showCancel() {
            return (
                (this.isEditMode && this.canEditOrLimited && this.isDirty) ||
                (this.isCreateMode && this.permissions.includes(permissionsSet.Create))
            )
        },
        showClose() {
            return this.isEditMode && !this.isDirty
        },
        showUnarchive() {
            return this.isReadMode && this.permissions.includes(permissionsSet.Edit) && this.entityStatus === -1
        },
    },
    methods: {
        copyClick() {
            this.$emit('copy')
        },
        editClick() {
            this.$emit('edit')
        },
        submitClick() {
            this.$emit('submit')
        },
        archiveClick() {
            this.$confirm({
                title: 'Confirm Archive',
                body: 'Are you sure you want to archvie this item?',
            }).then(confirmResult => {
                if (confirmResult) {
                    this.$emit('archive')
                }
            })
        },
        unarchiveClick() {
            this.$confirm({
                title: 'Confirm Unarchive',
                body: 'Are you sure you want to restore this item?',
            }).then(confirmResult => {
                if (confirmResult) {
                    this.$emit('unarchive')
                }
            })
        },
        approveClick() {
            this.$emit('approve')
        },
        flagClick() {
            this.$emit('flag')
        },
        saveClick(isClose) {
            this.$emit('save', isClose)
        },
        cancelClick() {
            this.$emit('cancel')
        },
        closeClick() {
            this.$emit('close')
        },
    },
}
</script>
